import React from "react";
import { Container } from "components";
import { Link, useLocation } from "@swiftcarrot/react-router";
import { useAuth } from "@swiftcarrot/react-auth";

export default function Header() {
  const { currentUser, setCurrentUser } = useAuth();
  const [, navigate] = useLocation();
  // const enableAI = currentUser.email !== "demo@lavrplatform.com";
  const enableAI = false;

  return (
    <div className="mb-5 shadow">
      <Container className="flex items-center h-[50px]">
        <Link
          href="/dashboard"
          className="inline-flex items-center h-full mr-auto"
        >
          <img src="/images/logo.png" className="h-[40px]" alt="LAVR Logo" />
        </Link>

        <div className="flex items-center space-x-2">
          <NavItem href="/dashboard">Home</NavItem>
          {/* <NavItem
            elementType="a"
            href={`https://ai.lavrplatform.com/?token=${currentUser.aiToken}`}
            target="_blank"
          >
            ChatGPT
          </NavItem>
          {enableAI ? (
            <NavItem
              elementType="a"
              href={`https://ai.lavrplatform.com/image?token=${currentUser.aiToken}`}
              target="_blank"
            >
              Image Generation
            </NavItem>
          ) : null} */}
          {/* TODO: add popover  */}
          <NavItem href="/profile">Profile</NavItem>
          <NavItem
            elementType="button"
            onClick={() => {
              setCurrentUser(null);
              window.localStorage.clear();
              navigate("/");
            }}
          >
            Logout
          </NavItem>
        </div>
      </Container>
    </div>
  );
}

const NavItem = ({ elementType, ...props }) => {
  return React.createElement(elementType, {
    ...props,
    className: "hover:bg-slate-300 rounded text-sm px-1.5 py-0.5",
  });
};

NavItem.defaultProps = {
  elementType: Link,
};
